/**
 * Returns true if the element has the specified Array, false otherwise.
 */
export default function contains(target, item) {
  return target.indexOf(item) > -1;
}
